export default __webpack_public_path__ + "public/assets/images/a64d06ffe5fff40deb60cfae0715d153.png";